import React from 'react';
import { useSelector } from 'react-redux';
import chunk from 'lodash.chunk';
import { Header, Grid, Segment, Loader } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { DOCUMENT_SET_LOAD_NAMESPACE } from 'services/documentSets/constants';

import LoadingGate from 'components/LoadingGate';

import JobAttribute from './components/JobAttribute';

import {
    makeSelectSchemaAttributeIds,
    makeSelectAssessmentsExist
} from './selectors';

interface Props {
    documentSetId: number; // eslint-disable-line
}

export default function JobAssessmentScores(props: Props): React.ReactElement {
    const { documentSetId } = props;
    const schemaAttributeIds = useSelector((state: AppState) =>
        makeSelectSchemaAttributeIds()(state, props)
    );
    const assessmentsExist = useSelector((state: AppState) =>
        makeSelectAssessmentsExist()(state, props)
    );
    const rowsLength = Math.ceil(schemaAttributeIds.length / 3);
    const schemaAttributeIdsChunked = chunk(schemaAttributeIds, rowsLength);

    const scores = (
        <Grid stackable relaxed columns={3}>
            {schemaAttributeIdsChunked.map((ids: number[]) => (
                <Grid.Column key={`${ids.join('-')}-${documentSetId}`}>
                    {ids.map((id: number) => (
                        <JobAttribute
                            key={`${id}-${documentSetId}`}
                            schemaAttributeId={id}
                            documentSetId={documentSetId}
                        />
                    ))}
                </Grid.Column>
            ))}
        </Grid>
    );
    const noScores = (
        <LoadingGate
            namespace={DOCUMENT_SET_LOAD_NAMESPACE}
            LoadingComponent={<Loader active inline="centered" />}
        >
            <div style={{ textAlign: 'center' }}>There are no scores.</div>
        </LoadingGate>
    );

    return (
        <Segment className="job-segment">
            <Header as="h3">Assessment Scores</Header>
            {assessmentsExist ? scores : noScores}
        </Segment>
    );
}
